import { createSlice } from "@reduxjs/toolkit";
import {
  onGetNotificationList,
  onSendBatchNotification,
} from './thunk';

export const initialState = {
  notificationList: [],
  errors: {}
};

const NotificationsSlice = createSlice({
  name: 'Notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(onGetNotificationList.fulfilled, (state: any, action: any) => {
      state.notificationList = action.payload;
    });
    builder.addCase(onGetNotificationList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onSendBatchNotification.fulfilled, (state: any, action: any) => {
      state.notificationList.unshift(action.payload);
    });
    builder.addCase(onSendBatchNotification.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
  }
});

export default NotificationsSlice.reducer;